var $a692f52e3d8a6649$exports = {};
$a692f52e3d8a6649$exports = {
    "info": `\u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A}`,
    "negative": `\u{62E}\u{637}\u{623}`,
    "notice": `\u{62A}\u{62D}\u{630}\u{64A}\u{631}`,
    "positive": `\u{62A}\u{645} \u{628}\u{646}\u{62C}\u{627}\u{62D}`
};


export {$a692f52e3d8a6649$exports as default};
//# sourceMappingURL=ar-AE.mjs.map
